export default [
    {
        path: '/old/guarTelCert',
        name: 'guarTelCert',
        component: () => import('@/views/old/member/guar/guarTelCert.vue')
    },
    {
        path: '/old/guarTermAgre',
        name: 'guarTermAgre',
        component: () => import('@/views/old/member/guar/guarTermAgre.vue')
    },
    {
        path: '/old/guarInfo',
        name: 'guarInfo',
        component: () => import('@/views/old/member/guar/guarInfo.vue')
    },
    {
        path: '/old/prntInfo',
        name: 'prntInfo',
        component: () => import('@/views/old/member/prnt/prntInfo.vue')
    },
    {
        path: '/old/sposInfo',
        name: 'sposInfo',
        component: () => import('@/views/old/member/prnt/sposInfo.vue')
    },
    {
        path: '/old/childList',
        name: 'childList',
        component: () => import('@/views/old/member/stdt/childList.vue')
    },
    {
        path: '/old/childInfo01',
        name: 'childInfo01',
        component: () => import('@/views/old/member/stdt/childInfo01.vue')
    },
    {
        path: '/old/childInfo02',
        name: 'childInfo02',
        component: () => import('@/views/old/member/stdt/childInfo02.vue')
    },
    {
        path: '/old/childInfo03',
        name: 'childInfo03',
        component: () => import('@/views/old/member/stdt/childInfo03.vue')
    },
]